"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authorizationsQuery = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const common_1 = require("./common");
const types_1 = require("../types");
/**
 *  @hidden
 */
function createAuthorizationFilters(variables) {
    const args = ['$size: Int, $start: Int'];
    const filters = [];
    const { fromId, toId, toKey, status, type } = variables;
    if (fromId === null || fromId === void 0 ? void 0 : fromId.length) {
        args.push('$fromId: String!');
        filters.push('fromId: { equalTo: $fromId }');
    }
    if (toId === null || toId === void 0 ? void 0 : toId.length) {
        args.push('$toId: String!');
        filters.push('toId: { equalTo: $toId }');
    }
    if (toKey === null || toKey === void 0 ? void 0 : toKey.length) {
        args.push('$toKey: String!');
        filters.push('toKey: { equalTo: $toKey }');
    }
    if (type) {
        args.push('$type: AuthTypeEnum!');
        filters.push('type: { equalTo: $type }');
    }
    if (status) {
        args.push('$status: AuthorizationStatusEnum!');
        filters.push('status: { equalTo: $status }');
    }
    return {
        args: `(${args.join()})`,
        filter: filters.length ? `filter: { ${filters.join()} }` : '',
        variables,
    };
}
/**
 * @hidden
 *
 * Get all authorizations with specified filters
 */
function authorizationsQuery(paddedIds, filters, size, start) {
    const { args, filter } = createAuthorizationFilters(filters);
    const orderBy = paddedIds
        ? `${types_1.AuthorizationsOrderBy.CreatedEventIdAsc}`
        : `${types_1.AuthorizationsOrderBy.CreatedAtAsc}, ${types_1.AuthorizationsOrderBy.CreatedBlockIdAsc}`;
    const query = (0, graphql_tag_1.default) `
    query AuthorizationsQuery
      ${args}
      {
      authorizations(
        ${filter}
        first: $size
        offset: $start
        orderBy: [${orderBy}]
      ) {
        totalCount
        nodes {
          id
          type
          fromId
          toId
          toKey
          data
          expiry
          status
          createdBlockId
          updatedBlockId
        }
      }
    }
  `;
    return {
        query,
        variables: (0, common_1.removeUndefinedValues)(Object.assign(Object.assign({}, filters), (0, common_1.getSizeAndOffset)(size, start))),
    };
}
exports.authorizationsQuery = authorizationsQuery;
//# sourceMappingURL=authorizations.js.map